import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useWebSocket } from "./useWebSocket";
import { showContractPaymentNotification } from "../redux/Slices/notificationSlice";
import { handleWebSocketMessage } from "../redux/Slices/chatSlice";
import { RootState } from "../redux/store";
import { RoleEnum } from "../modules/shared/model";

const useContractNotification = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);

  const { isConnected } = useWebSocket({
    onMessage: (message) => {
      console.log("WebSocket message received in contract notification hook:", message);
      
      // Handle all WebSocket messages through the chat slice
      // dispatch(handleWebSocketMessage(message));
      
      // Specifically handle new_contract messages
      if (message.type === "new_contract") {
        console.log("Processing new_contract message:", message);
        
        // Check if current user is a professional (local or international)
        const userRoleId = Number(user?.role?.id);
        const isProfessional = userRoleId === RoleEnum.professional || 
                              userRoleId === RoleEnum.internationl_professional;
        
        if (!isProfessional) {
          console.log("Skipping contract notification display - user is not a professional");
          return;
        }

        const { contractId, amount, currency, professionalName, clientName, chatId } = message.detail;
        
        console.log("Dispatching contract payment notification:", {
          contractId,
          amount,
          currency,
          professionalName,
          clientName,
          chatId
        });
        
        // Add a small delay to ensure proper state management
        setTimeout(() => {
          // Show the contract payment notification only to professionals
          dispatch(showContractPaymentNotification({
            contractId: `${contractId}-${Date.now()}`, // Add timestamp to ensure uniqueness
            amount,
            currency,
            professionalName,
            clientName,
            chatId
          }));
        }, 100);
      }
    },
    onError: (error) => {
      console.error("WebSocket error in contract notification hook:", error);
    }
  });

  return {
    isConnected
  };
};

export default useContractNotification;
